import { JsonObject } from 'ta-json';
import { WebhookOptions } from '@ess/jg-rule-executor';
import { WebhookFlowType } from '@ess/jg-rule-executor/dist/src/domain/webhook-flow-type';
import { PortalWebhookUrls } from '@src/app/model/portal-webhook-urls';
import { WebhookOptionsInput } from '@src/app/generated/globalTypes';
import { GetAllRetailers_allRetailers_edges_node_retailerOptions_webhookOptions } from '@src/app/generated/GetAllRetailers';

@JsonObject()
export class PortalWebhookOptions extends WebhookOptions {
  constructor(flowType: WebhookFlowType, webhookUrls: PortalWebhookUrls) {
    super(flowType, webhookUrls);
  }

  public toGqlInput(): WebhookOptionsInput {
    return {
      flowType: this.flowType,
      webhookUrls: (this.webhookUrls as PortalWebhookUrls).toGqlInput(),
    };
  }

  static fromGql(gql: GetAllRetailers_allRetailers_edges_node_retailerOptions_webhookOptions): PortalWebhookOptions {
    return new PortalWebhookOptions(
      WebhookFlowType[gql.flowType], PortalWebhookUrls.fromGql(gql.webhookUrls)
    );
  }
}
